<template>
  <div class="salesman-form-record">
    <Timeline>
      <TimelineItem v-for="(item,i) in list" :key="i">
        <div class="dian" :class="{'active':i==0}" slot="dot"></div>
        <div class="row">
          <span class="text1">更改字段</span>
          <span class="text2">“{{item.propertyname}}”，
            <span v-if="item.eyeShow1">【{{item.oldvalueShow}}】</span>
            <span v-else>【{{item.oldvalue}}】</span>
            <template v-if="(item.property=='mobile'||item.property=='idNo' ||item.property == 'cardNo' ||item.property == 'address'||item.property == 'email'||item.property == 'userContactsMobileOne'||item.property == 'userContactsMobileTwo') && item.oldvalue"">
              <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow1" @click="openEye(item,'eyeShow1')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item,'eyeShow1')"></i>
            </template>
            →
            <span v-if="item.eyeShow2">【{{item.newvalueShow}}】</span>
            <span v-else>【{{item.newvalue}}】</span>
            <template v-if="(item.property=='mobile'||item.property=='idNo' ||item.property == 'cardNo' ||item.property == 'address'||item.property == 'email'||item.property == 'userContactsMobileOne'||item.property == 'userContactsMobileTwo') && item.newvalue"">
              <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow2" @click="openEye(item,'eyeShow2')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item,'eyeShow2')"></i>
            </template>
          </span>
          <span class="by">操作人：{{item.createName}}</span>
        </div>
        <p class="time">{{item.createTime | cutString(16)}}</p>
      </TimelineItem>
    </Timeline>
    <no-data v-if="list.length==0&&!loading"></no-data>
  </div>
</template>

<script>
import {common} from "@/api/mixins";
export default {
  mixins:[common],
  components: {},
  props: {},
  data() {
    return {
      loading:false,
      list:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.indoorStaffId = this.$route.query.indoorStaffId;
  },
  methods: {
    setData(){
      this.loading = true;
      this.$http({
        url: '/buz/userChangeRecord/read/list',
        type: 'post',
        data: {
          indoorStaffId: this.indoorStaffId,
          pageNo: 1,
          pageSize: 999
        },
      }).then((res) => {
        this.loading = false;
        this.list = res.data;
      }).catch((e)=>{
        this.loading = false;
      })
    },
    // 解密
    openEye(item,eyeKey){
      let type = "";
      if (item.property == "mobile") {
        type = '2';
      } else if (item.property == "idNo") {
        type = '1';
      } else if (item.property == "cardNo") {
        type = '3';
      } else if (item.property == "email") {
        type = '4';
      } else if (item.property == "address") {
        type = '5';
      } else if (item.property == "userContactsMobileOne" || item.property == "userContactsMobileTwo") {
        type = '6';
      } else {
        return;
      }
      if(!item[eyeKey]){
        this.descrypt({
          query:item.id,
          operationFunction:eyeKey=='eyeShow1'?'26':'27',
          operationType:type,
        },item,eyeKey=='eyeShow1'?'oldvalueShow':'newvalueShow').then(()=>{
          this.$set(item,eyeKey,true);
        })
      }else{
        this.$set(item,eyeKey,false);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.salesman-form-record {
  min-height: calc(100vh  - 80px);
  /deep/ {
    .ivu-timeline-item-content {
      top: -5px;
    }
    .ivu-timeline-item-head {
      background: transparent;
    }
    .ivu-timeline-item-tail {
      border-left: 1px dashed #eee;
      top: 8px;
    }
  }
  .dian {
    width: 11px;
    height: 11px;
    background-color: #F7F7F7;
    margin: auto;
    border-radius: 50%;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #E8F0FF;
    &::before{
      content: "";
      display: block;
      width: 7px;
      height: 7px;
      background: #D4D5D8;
      border-radius: 50%;
    }
    &.active::before {
      background: #236DFF;
    }
  }
  .row {
    font-size: 12px;
    width: 710px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .text1 {
      color: #727C8E;
    }
    .text2 {
      color: #515C6F;
      display: flex;
      align-items: center;
    }
    .by {
      margin-left: auto;
      color: #A8ADB7;
    }
  }
  .time {
    color: #515C6F;
    font-size: 12px;
    padding-bottom: 10px;
  }
}
</style>